
import { FC } from "react";
import { Typography } from "../../core/Typography/Typography";
import { TypographyColor, TypographyVariant } from "../../../constants/typography";
import { Inventory, InventoryBundleData } from "@onmo/graphql/graphql";
import { StaticImage } from "../StaticImage";
import { useStyles } from "./VoucherInventory.style";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../../../constants/historyGaming";

export const VoucherInventory: FC<{ item: Inventory }> = ({
  item
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const navigateToVoucherDetails = () => {
    navigate(`${PageRoutes.VoucherDetail}/${item.id}`);
  }

  return (
    <div
      className={classes.card}
      data-gamepad={`store-${item.id}`}
      data-selected-class="selected"
      onClick={navigateToVoucherDetails}
    >
      <StaticImage
        src={(item.data as InventoryBundleData).previewUrl}
        className={classes.voucherIconWrapper}
      />

      <Typography
        variant={TypographyVariant.BodyB5Bold}
        color={TypographyColor.Gray}
        className={classes.title}
      >
        {item.title}
      </Typography>
    </div>
  )
}